/*global Backbone, $, _, ofs, moment */
'use strict';

var DesktopHeaderTabView = Backbone.View.extend({
  el: '#header',
  events: {
    'click .nav.desktop a': 'highlightTab'
  },
  searchPanelHeight: 0,
  servicePanelHeight: 0,
  accountPanelHeight: 0,
  transitionDuration: 400,
  initialize: function(options) {
    this.flux = options.flux;

    this.$el.find('#id-region').select2({minimumResultsForSearch: 99});
    this.$el.find('#id-sleeps').select2({minimumResultsForSearch: 99});

    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if (isTouchDevice) {
      this.transitionDuration = 0;
    }

    // Grab heights of all .header panels
    var panelWrap = this.$el.find('.panel-wrap');
    panelWrap.css({'height': '0px', 'overflow': 'hidden'});
    panelWrap.find('.panel').show();

    this.showSearch = false;
    if ($('.header .search-form').hasClass('homepage-functionality')) {
      this.showSearch = true;
    }

    this.searchPanelHeight = panelWrap.find('.search').outerHeight();
    this.servicePanelHeight = panelWrap.find('.service').outerHeight();
    this.accountPanelHeight = panelWrap.find('.account').outerHeight();

    panelWrap.css({'height': 'auto', 'overflow': 'visible'});
    panelWrap.find('.panel').hide();

    // IE8 bug: any element resize triggers $(window).resize... so do not bind
    // stackoverflow.com/questions/1852751/window-resize-event-firing-in-internet-explorer
    if (!$('html').hasClass('lt-ie9')) {
      var panelRemoveCheck = _.debounce(this.panelRemove, 300);
      $(window).resize(panelRemoveCheck);
    }
  },
  highlightTab: function(event) {
    this.undelegateEvents();
    var navItem = this.$el.find('.nav-item');
    var clickedTab = $(event.currentTarget).parent('.nav-item');

    if (clickedTab.hasClass('active')) {
      clickedTab.removeClass('active');
    } else {
      navItem.removeClass('active');
      clickedTab.addClass('active');
    }

    this.switchPanel(clickedTab);
  },
  switchPanel: function(clickedTab) {
    var self = this;
    var searchForm = this.$el.find('.search-form');

    // Selects the panel corresponding to the tab the user clicked on
    var panel = this.targetPanel(clickedTab);

    var correctHeight;

    if (panel.hasClass('active')) {
      // Close panel; selected panel already open
      this.$el.find('.panel.active')
        .removeClass('active')
        .transition({
          height: 0,
          duration: this.transitionDuration
        }, function() {
          this.css({'display': 'none'});
          self.delegateEvents();
        });

      if (this.showSearch) {
        if (panel.hasClass('search') && searchForm.css('opacity') === 0) {
          searchForm.css({'display': 'block', 'opacity': 0}).transition({opacity: 1, duration: this.transitionDuration});
        } else if (!panel.hasClass('search')) {
          searchForm.css({'display': 'block', 'opacity': 0}).transition({opacity: 1, duration: this.transitionDuration});
        }
      } else {
        searchForm.transition({opacity: 0, duration: self.transitionDuration}, function() {
          this.css({'display': 'none'});
          self.delegateEvents();
        });
      }
    } else if (this.$el.find('.panel').hasClass('active')) {
      // Hide previous panel, open new panel
      var currentPanelHeight = this.$el.find('.panel.active').outerHeight();

      if (clickedTab.hasClass('search')) {
        correctHeight = this.searchPanelHeight;
      } else if (clickedTab.hasClass('service')) {
        correctHeight = this.servicePanelHeight;
      } else if (clickedTab.hasClass('account')) {
        correctHeight = this.accountPanelHeight;
      }

      panel.css({'height': currentPanelHeight + 'px'});

      this.$el.find('.panel.active .row')
        .transition({
          opacity: 0,
          duration: this.transitionDuration
        }, function() {
          self.$el.find('.panel.active').hide().removeClass('active');
          panel.show().addClass('active');

          panel.transition({
            height: correctHeight,
            duration: self.transitionDuration
          }, function() {
            this.find('.row').transition({opacity: 1, duration: self.transitionDuration});
          });

          if (panel.hasClass('search')) {
            searchForm.css({'display': 'block', 'opacity': 0})
              .transition({opacity: 1, duration: self.transitionDuration});
            self.delegateEvents();
          } else {
            searchForm.transition({
              opacity: 0, duration: self.transitionDuration
            }, function() {
              this.css({'display': 'none'});
              self.delegateEvents();
            });
          }
        });

    } else {
      // Open panel; no panels open currently
      if (clickedTab.hasClass('search')) {
        correctHeight = this.searchPanelHeight;
      } else if (clickedTab.hasClass('service')) {
        correctHeight = this.servicePanelHeight;
      } else if (clickedTab.hasClass('account')) {
        correctHeight = this.accountPanelHeight;
      }

      panel.find('.row').css({'opacity': 1});
      panel.addClass('active').css({'display': 'block', 'height': 0}).transition({height: correctHeight, duration: this.transitionDuration}, function() {
        self.delegateEvents();
      });

      if (panel.hasClass('search') && searchForm.is(':visible')) {
        // do nothing, as searchForm is already visible
      } else if (panel.hasClass('search') && !searchForm.is(':visible')) {
        searchForm.css({'display': 'block', 'opacity': 0}).transition({opacity: 1, duration: this.transitionDuration});
      } else {
        searchForm.transition({opacity: 0, duration: this.transitionDuration}, function() {
          this.css({'display': 'none',  'height': currentPanelHeight});
        });
      }
    }
  },
  targetPanel: function(clickedTab) {
    if (clickedTab.hasClass('search')) {
      return this.$el.find('.search.panel');
    } else if (clickedTab.hasClass('service')) {
      return this.$el.find('.service.panel');
    } else if (clickedTab.hasClass('account')) {
      return this.$el.find('.account.panel');
    }
  },
  panelRemove: function() {
    var activePanel = $('.panel.active');
    var activeNavItem = $('.nav-item.active');
    var searchForm = $('#header .search-form');

    if ($(window).width() < 600) {
      activePanel.removeClass('active').slideUp();
      activeNavItem.removeClass('active');
      searchForm.transition({opacity: 0, duration: this.transitionDuration}, function(){
        this.css({'display': 'none'});
      });
    } else if($(window).width() < 1000 && $(window).width() > 600) {
      activePanel.removeClass('active').slideUp();
      activeNavItem.removeClass('active');
      if (searchForm.hasClass('homepage-functionality')){
        searchForm.css({'display': 'block', 'opacity': 0}).transition({opacity: 1, duration: this.transitionDuration});
      } else {
        searchForm.transition({opacity: 0, duration: this.transitionDuration}, function(){
          this.css({'display': 'none'});
        });
      }
    } else if ($(window).width() > 1000){
      activePanel.removeClass('active').slideUp();
      activeNavItem.removeClass('active');
      if (searchForm.hasClass('homepage-functionality')){
        searchForm.css({'display': 'block', 'opacity': 0}).transition({opacity: 1, duration: this.transitionDuration});
      } else {
        searchForm.transition({opacity: 0, duration: this.transitionDuration}, function(){
          this.css({'display': 'none'});
        });
      }
    }
  }
});

var MobileHeaderTabView = Backbone.View.extend({
  el: '#container',
  htmlBody: $('body'),
  initWindowWidth: 0,
  events: {
      'click .burger a': 'toggleFlyout',
      'click .contact a': 'togglePanel',
      'click .select-list': 'toggleSearch'
  },
  initialize: function(options) {
    this.flux = options.flux;

    var self = this;
    this.initWindowWidth = $(window).width();
    var hideFlyoutCheck = _.debounce(function(){
      if (self.initWindowWidth !== $(window).width() && self.$el.hasClass('visible')) {
          self.hideFlyout();
      }
    }, 300);
    $(window).resize(hideFlyoutCheck);
  },
  toggleFlyout: function(){
    // Prevent iPad flicker; too hacky?
    $('.flyout').show();

    this.$el.find('.burger').addClass('active');
    this.$el.css({'width': this.$el.width()});

    if (this.$el.hasClass('visible')){
      this.hideFlyout();
    } else {
      this.showFlyout();
    }
  },
  showFlyout: function(){
    var self = this;
    this.$el.addClass('visible').transition({x: '260px'}, function(){
      self.htmlBody.css({'position': 'fixed'});
    });
  },
  hideFlyout: function(){
    this.$el.find('.burger').removeClass('active');

    var self = this;
    this.$el.removeClass('visible').transition({x: '0'}, function(){
      self.resetContainerWidth();
      self.htmlBody.css({'position': 'static'});
      $('.flyout').hide();
    });
  },
  windowWidthCheck: function() {
    if ($(window).width() > 1000 && this.$el.hasClass('visible')) {
      this.hideFlyout();
    }
  },
  resetContainerWidth: function(){
    // -webkit-transform is removed as it affects position: fixed;
    this.$el.css({'width': '100%', '-webkit-transform': ''});
  },

  togglePanel: function(){
    if (this.$el.find('.header .search-form').hasClass('active')){
      this.$el.find('.header .search-form').removeClass('active').hide();
    }

    var panel = this.$el.find('.panel.contact');

    if (panel.hasClass('active')){
      this.hidePanel(panel);
    } else {
      this.showPanel(panel);
    }
  },
  showPanel: function(panel){
    this.$el.find('.nav-item.phone').addClass('active');
    panel.addClass('active').show();
  },
  hidePanel: function(panel){
    this.$el.find('.nav-item.phone').removeClass('active');
    panel.removeClass('active').hide();
  },
  toggleSearch: function(){
    var panel = this.$el.find('.panel.contact');
    if (panel.hasClass('active')){
      this.hidePanel(panel);
    }

    var searchPanel = this.$el.find('.header .search-form');
    if (searchPanel.hasClass('active')){
      this.$el.find('#header .search-form').removeClass('active').hide();
    } else {
      this.$el.find('#header .search-form').addClass('active').css({'opacity': 1}).show();
    }
  }
});

var QuickSearchFormView = Backbone.View.extend({
  el: '#header .search-form',
  events: {
      'change #header-quicksearch_start_date': 'updateDepartureDate',
      'change #header-quicksearch_end_date' : 'shouldUpdateDateStore',
      'change #header-quicksearch_sleeps' : 'updateGuestStore'
  },
  initialize: function(options) {
    this.flux = options.flux;

    var startDate = this.flux.stores.DateStore.getFormattedStartDate();
    var endDate = this.flux.stores.DateStore.getFormattedEndDate();
    var guests = this.flux.stores.GuestStore.getNumberOfGuests();
    this.$el.find('#header-quicksearch_start_date').val(startDate);
    this.$el.find('#header-quicksearch_end_date').val(endDate);
    var pikadayArray = ofs.components.pikadayElements;
    for (var i = 0; i < pikadayArray.length; i++) {
        if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
            pikadayArray[i].setDate(startDate,false);
        } else if (pikadayArray[i]._o.field.id === 'header-quicksearch_end_date') {
            pikadayArray[i].setDate(endDate,false);
        }
    }
    this.$el.find('#header-quicksearch_sleeps').val(guests).trigger("change");
  },

  updateDepartureDate: function(){
      var startDate;
      var pikadayArray = ofs.components.pikadayElements;
      for (var i = 0; i < pikadayArray.length; i++) {
          if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
              startDate = pikadayArray[i].getDate();
          }
      }

      for (var j = 0; j < pikadayArray.length; j++) {
          if (pikadayArray[j]._o.field.id === 'header-quicksearch_end_date') {
              pikadayArray[j].gotoDate(startDate);
              var endDate = pikadayArray[j].getDate();
              this.updateDateStore(startDate, endDate);
          }
      }

  },

  updateDateStore : function (startDate, endDate) {
    if (startDate !== null && endDate !== null) {
      var daterange = moment().range(moment(startDate), moment(endDate));
      this.flux.actions.calendar.completeRangeSelection(daterange, null);
    }
  },

  shouldUpdateDateStore : function(event) {
    var pikadayArray = ofs.components.pikadayElements;
    var startDate = null;
    var endDate = null;
    for (var i = 0; i < pikadayArray.length; i++) {
      if (pikadayArray[i]._o.field.id === 'header-quicksearch_start_date') {
        startDate = pikadayArray[i].getDate();
      } else if (pikadayArray[i]._o.field.id === 'header-quicksearch_end_date') {
        endDate = pikadayArray[i].getDate();
      }
    }

    this.updateDateStore(startDate, endDate);
  },

  updateGuestStore : function(event) {
    this.flux.actions.guest.updateGuestNumber(event.target.value);
  }
});

var isoSearchForm = function() {
  $('.search-form form').submit(function(event) {
    $(event.target).find('input[data-ofs-component="datepicker"]').each(function(index, input) {
      var date = $(input).data('picker').getMoment();
      if (date) {
        $(input).val(date.format("YYYY-MM-DD"));
      }
    });
  });
};

module.exports = function(flux) {
  new DesktopHeaderTabView({flux});
  new MobileHeaderTabView({flux});
  new QuickSearchFormView({flux});
  isoSearchForm();
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/header/index.js
 **/